import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import './css/barista-tab.css';
import './css/mediaquery.css';
import './fonts/stylesheet_roboto.css';
import './fonts/all.min.css';


// pages
import Landing from './pages/Landing';
import Login from './pages/login';
import Served from './pages/Served';
// pages

function App() {
  return(
    <Router>
      <Routes>
        <Route path="/" element={<Landing/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/served" element={<Served/>} />
      </Routes>
    </Router>
  )
}

export default App;
